// extracted by mini-css-extract-plugin
export default {"verifiedWrapper":"Verified_verifiedWrapper__ahq0g"};